module.exports = __webpack_public_path__ + "media/images/icons/email_share-d32f7c3793e11b79c6a41fc6e7fb9d14.svg";